import React, { Fragment } from 'react';
import Modal from 'library/components/modal';
import PropTypes from 'prop-types';
import EditTargetModal from 'apps/hiring/components/edit-target-modal';

class EditTarget extends React.Component {
  static defaultProps = {
    children: 'Edit Target',
    onTargets: ()=>{}
  }

  state = {
    active: false,
    edit: false
  }

  handleEdit = () => {
    this.setState({ edit: true });
  }

  toggleModal = async () => {
    this.setState({
      active: !this.state.active,
      edit: false
    });
  }

  handleOnTargets = (targets) => {
    this.setState({
      active: false
    });
    this.props.onTargets(targets);
  }

  render() {
    const {
      component:Component='button',
      children,
      id,
      reload,
      node_id,
      ...props
    } = this.props;

    return (
      <Fragment>
        <Component onClick={this.toggleModal} {...props}>{children}</Component>
        <Modal onClose={this.toggleModal} active={this.state.active}>
          <EditTargetModal
            node_id={node_id}
            handleEdit={this.handleEdit}
            reload={reload}
            onClose={this.toggleModal}
            key={id}
            id={id}
          />
        </Modal>
      </Fragment>
    );
  }
}

EditTarget.propTypes = {
  id: PropTypes.number,
  children: PropTypes.object,
  component: PropTypes.string,
  onTargets: PropTypes.func,
  reload: PropTypes.func,
  node_id: PropTypes.number
};

export default EditTarget;
